import app, { Component } from 'apprun';
import { serializeObject, companies } from './api';
import { isValid, showSaveStatusMessage } from './utils';

export default class CompanyNewComponent extends Component {
  state = { };

  view = () => <div>
    <form id="copmNewForm" autocomplete="off">
      <div class="list-group">
        <div class="list-group-item">
          Name: <input id="companyName" name="companyName" class='pull-right' data-validate />
          <div id="companyNameErrMsg" class="text-danger"></div>
        </div>
        <div class="list-group-item">
          Open Date: <input $pikaday id="compOpenDate" name="openDate" class='pull-right' placeholder="DD-MMM-YYYY" data-validate="Date" />
          <div id="compOpenDateErrMsg" class="text-danger"></div>
        </div>
      </div>
    </form>
    <div class="edit-buttons pull-right">
      <button class="btn btn-xs btn-primary" $onclick='save'>Save</button>
      <button class="btn btn-xs btn-default" $onclick='cancel'>cancel</button>&nbsp;
    </div>
  </div>;

  update = {
    save: async () => {
      try {
        const formName = 'copmNewForm';
        if (!isValid(formName)) {return;}
        const formData = serializeObject(document.getElementById(formName));
        const result = await companies.post(0, formData);
        showSaveStatusMessage('company');
        app.run('#company', result, formData['companyName']);
      } catch {
        showSaveStatusMessage();
      }
    },
    cancel: () => {
      app.run('#clear-panel', 'compNew');
    }
  };
}
